import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions } from "vuex";

export default {
  methods: _extends({}, mapMutations({
    setLeaveToDashboard: "dashboard/details/setLeaveToDashboard",
    emptyData: "affiliations/form/emptyData"
  }), {
    returnDashboard: function returnDashboard() {
      this.setLeaveToDashboard(true);
      this.$nextTick(function () {
        this.emptyData();
        this.$router.push("/dashboard");
      });
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/reject-affiliation.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/reject-affiliation.vue
// module chunks = 0 1 2 3